module.exports = __webpack_public_path__ + "images/emoji/cookie.000bafc7d92fe1af442a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/cookie.png
// module id = Jna3
// module chunks = 24